/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useQuery } from '@tanstack/react-query';

// Lib
import { apiClient } from '@lib/api-client';

// Constants
import { queryKeys } from '@config/constants/query-keys';

// Types
import { TUser } from '@global-types/api/api';

// Mocks
import { useLocation } from 'react-router';
import startsWith from 'lodash/startsWith';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getWhoAmI = async (): Promise<TUser> => {
	return await apiClient.get('/auth/whoami', {
		params: {
			populate: 'avatar',
		},
	});
};

/* -------------------------------------------------------------------------- */
/*                                     Hook                                   */
/* -------------------------------------------------------------------------- */
export const useWhoAmI = () => {
	let location = useLocation();

	return useQuery({
		queryKey: [queryKeys.whoAmI.key],
		queryFn: () => getWhoAmI(),
		staleTime: Infinity,
		enabled:
			!startsWith(
				location.pathname,
				'/catalog-measurabilities'
			) &&
			!startsWith(
				location.pathname,
				'/catalog-additionalities'
			),
	});
};
